// extracted by mini-css-extract-plugin
export var divider = "_po-0";
export var systemMessage = "_po-1";
export var systemMessageWrapper = "_po-2";